import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Paper, Typography, TextField, Button, MenuItem } from "@material-ui/core";
import t from "../../../languages/pl";
import { notArrayOrEmpty } from '../../../utils/helpers';
import guid from './../../../utils/guid';

const useStyles = theme => ({
    paper: {
        margin: theme.spacing(1),
        padding: theme.spacing(2),
        minHeight: 220
    },
    container: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        margin: theme.spacing(2)
    },
    button: {
        marginTop: theme.spacing(1)
    }
});

const MobileAppKey = props => {
    const { classes, theme, data, groupOptions, onNewKeyRequest} = props;
    const [groupId, setGroupId] = useState(data.grupa_id);

    useEffect(() => {
        setGroupId(data.grupa_id);
    }, [data]);

    const printOptions = options => {
        if(notArrayOrEmpty(options))
            return;
        return options.map(option => (
            <MenuItem key={guid()} value={option.id}>{option.name}</MenuItem>
        ));
    };

    return (
        <Paper
            square
            className={classes.paper}
        >
            <Typography variant="subtitle1">
                {t.mobileAppKey}
            </Typography>
            <div className={classes.container}>
                <TextField
                    label={t.group}
                    fullWidth
                    select
                    value={groupId}
                    onChange={(e) => setGroupId(e.target.value)}
                >
                    <MenuItem value=""><em>{t.all}</em></MenuItem>
                    {printOptions(groupOptions)}
                </TextField>
                <TextField
                    label={t.mobileAppKey}
                    fullWidth
                    InputProps={{
                        readOnly: true
                    }}
                    value={data.klucz_mobilny}
                    style={{marginTop: theme.spacing(1)}}
                />
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    className={classes.button}
                    onClick={() => onNewKeyRequest(groupId)}
                >
                    {t.generateKey}
                </Button>
            </div>
        </Paper>
    );
};

MobileAppKey.propTypes = {
    classes: PropTypes.object,
    theme: PropTypes.object,
    data: PropTypes.object,
    groupOptions: PropTypes.array,
    onNewKeyRequest: PropTypes.func
};

export default withStyles(useStyles, { withTheme: true })(MobileAppKey);
